export type ThemeMode = "light" | "dark" | "system";

const STORAGE_KEY = "driverflow-theme";
const media = () => window.matchMedia("(prefers-color-scheme: dark)");

export function storedTheme(): ThemeMode {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (value === "light" || value === "dark" || value === "system") return value;
  } catch { /* private mode — fall back to the system preference. */ }
  return "system";
}

export function resolveTheme(mode: ThemeMode): "light" | "dark" {
  return mode === "system" ? (media().matches ? "dark" : "light") : mode;
}

export function applyTheme(mode: ThemeMode): void {
  const resolved = resolveTheme(mode);
  document.documentElement.dataset.theme = resolved;
  document.documentElement.style.colorScheme = resolved;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", resolved === "dark" ? "#171d19" : "#f7f7f2");
}

export function setTheme(mode: ThemeMode): void {
  try { window.localStorage.setItem(STORAGE_KEY, mode); } catch { /* Session-only theme is acceptable. */ }
  applyTheme(mode);
}

/** Keeps "system" mode in sync when the OS flips appearance mid-session. */
export function watchSystemTheme(onChange: () => void): () => void {
  const listener = () => { if (storedTheme() === "system") { applyTheme("system"); onChange(); } };
  media().addEventListener("change", listener);
  return () => media().removeEventListener("change", listener);
}
